module.exports = __webpack_public_path__ + "static/media/catering-1.741537d9.jpg";